import { Button, ButtonVariant, Tag } from "@blueprintjs/core"
import IScalarForm from "../interface/IScalarForm"
import Scalar from "./Scalar"
import { __ } from "src/libs/utilities"
import { Gallery } from "src/libs/useful"
import { NAVIGATION_POSITION_TYPE, NAVIGATION_SIZE_TYPE, NAVIGATION_TYPE } from "src/libs/useful/gallery/Gallery"
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts"

/* Protopia Ecosystem component */
export interface IImageRadioCarouselProps {
   
}
const ImageRadioCarousel = (props: IScalarForm): JSX.Element => {
   return <Scalar 
        { ...props } 
        enabledForm={<ImageRadioEnabled {...props} />}
        desabledForm={<ImageRadioDisabled {...props} />}
    /> 
}
export default ImageRadioCarousel

const ImageRadioEnabled  = ( props: IScalarForm ): JSX.Element => {
    const _value = typeof (props.value || props.default ) === "object" 
        ? 
        (props.value || props.default )
        : 
        {
            _id: (props.value || props.default ),
            title: (props.value || props.default ),
            img: "",
            height: props.height || 45
        } 
    const onClick = ( i:number) => {
        const v = [ ...props.values || [] ].filter((val, n) => n === i)[0]
        if( props.onChange && v ) {
            props.onChange(
                v._id ? v._id : v, 
                props.field, 
                ""
            )
        }
    }
    const data: any = {
        is_pagination: true,
        columns: props.stepSize || 1,
        carousel_nav: NAVIGATION_TYPE.SQUARE,
        carousel_nav_size: NAVIGATION_SIZE_TYPE.NORMAL,
        gap: 20,
        height: props.height || 110
    }
    const cards: any = props.values?.map((value: any, i) => {
        const checked = Array.isArray( _value )
            ?
            !!_value.filter( v => v === value._id ).length
            :
            value._id === _value._id
        return <Button
            key={i}
            role="button"
            className="btn-stretch"
            onClick={( ) => onClick( i )}
            data-v={ value._id }
            fill
            variant={ ButtonVariant.MINIMAL }
        >
            <div className="w-100 flex-centered flex-column ">
                <img
                    src={ value.img }
                    alt={ "" }
                    className={`scalar-imgage-radio-img mb-1 ${value.className || ""} `}
                    style={{
                        height: data.height - 20,
                        top: 0,
                        opacity: checked
                            ? 
                            value.icon_opacity
                                ? 
                                value.icon_opacity
                                : 
                                1
                            : 
                            0.33,
                    }}
                />
                <div className="scalar-imgage-radio-title" style={{...props.style, maxWidth: "100%" }}>
                    { __(value.title) }
                </div>
                <div 
                    className="scalar-imgage-radio-description" 
                    style={{ maxWidth: "100%" }}
                >
                    { __(value.description) }
                </div> 
            </div>
        </Button>
    })
    const i = !!Array.isArray(props.values) ?  props.values.findIndex((card: any) => card._id === ( typeof _value === "string" ? _value : _value._id )) :-1
    return <div 
        className="" 
        style={{ 
            width: "calc(100% - 76px)", 
            marginLeft: "35px" 
        }}
    > 
        <div>
            <Gallery 
                start={ i }
                items={ cards } 
                itemWidth="100%"                
                itemHeight={ data.height + 40 } 
                pagination={ data.is_pagination }
                navigation
                navigationType={ data.carousel_nav}
                navigationThemeType={ data.carousel_nav_theme }
                navigationSizeType={ data.carousel_nav_size }
                navigationDesignType={ data.carousel_nav_type }
                navigationPositionType={ NAVIGATION_POSITION_TYPE.MIDDLE_OUTER } 
                count={ data.columns }
                // count={{
                //     [WINDOW_WIDTH.PANEL]    : data.columns,
                //     [WINDOW_WIDTH.LARGE]    : data.columns,
                //     [WINDOW_WIDTH.SCREEN]   : data.columns,
                //     [WINDOW_WIDTH.TABLET]   : 1,
                //     [WINDOW_WIDTH.MOBILE]   : 1,
                //     [WINDOW_WIDTH.SMALL]    : 1,
                // }}
                loop
                type="element"
                padding={ data.gap || 0 }
            />
        </div> 
        {
            !!_value 
                ?
                Array.isArray( _value )
                    ?
                    !!_value.map(v => {
                        return <div key={ v._id } className='w-100'>
                            <div className='mt-1title text-center w-100'>{__( typeof v === "string" ? v : v.title )} </div>
                            <div className='mb-1 small text-center w-100'>{__( typeof v === "string" ? "" : v.description )} </div>
                        </div>
                    })
                    :
                    <div className='w-100 m-3'>
                        <div className=' text-center title w-100'>{__(  typeof _value === "string" ? _value : _value.title )}</div>
                        {
                            (props.values || [])
                            .filter(val => val._id === ( typeof _value === "string" ? _value : _value._id ) )
                            .map(v => {
                                return <div className=' text-center small w-100' key={ v._id }>{ __(  typeof v === "string" ? "" : v.description ) } </div>
                            }) 
                        }
                    </div>
                :
                <></>
        }
    </div>
}

const ImageRadioDisabled  = ( props: IScalarForm ): JSX.Element => {
    const checkedValue = props.values?.filter( v => v._id === props.value )[0]
    const _value = typeof (props.value || props.default ) === "object" 
        ? 
        (props.value || props.default )
        : 
        {
            _id: (props.value || props.default ),
            title: (props.value || props.default ),
            img: "",
            height: 45
        } 
    return checkedValue
        ?
        <div>
            <img
                src={checkedValue.img}
                alt={_value.title}
                className="scalar-imgage-radio-img"
                style={{
                    height: checkedValue.height,
                    top: 0 
                }}
            />
            <div>{ _value.title }</div>
        </div>
        :
        <Tag>
            { _value.title }
        </Tag>
}